<template>
  <div id="kt_header" ref="kt_header" class="header flex-column header-fixed">
    <!-- FOR MOBILE -->
    <div :class="`${!isMobile ? 'd-none' : ''}`">
      <div class="header-top">
        <div class="w-100 d-lg-flex mr-0 ml-0 justify-content-between p-0">
          <div class="d-flex">
            <div class="d-none d-lg-flex align-items-center mr-10">
              <router-link to="/">
                <img
                  alt="Logo"
                  :src="layoutConfig('self.logo.default')"
                  class="max-h-30px"
                />
              </router-link>
            </div>
            <div class="d-none d-lg-flex align-items-center mr-3">
              <ul
                class="header-tabs nav align-self-end font-size-lg"
                role="tablist"
              >
                <li
                  class="nav-item"
                  @click="handleShowSubmenu(0)"
                  @mouseover="
                    (event) => {
                      tabIndex = 0;
                      handleShowSubmenu(0);
                      setActiveTab(event);
                      storeTabID(item.name);
                    }
                  "
                >
                  <a
                    class="nav-link py-4 px-6 active"
                    @click="
                      (event) => {
                        tabIndex = 0;
                        storeTabID('home');
                        setActiveTab(event);
                      }
                    "
                    data-tab="0"
                    data-toggle="tab"
                    href="#"
                    id="home"
                    role="tab"
                    aria-selected="true"
                    >Home</a
                  >
                </li>
                <li
                  class="nav-item"
                  v-for="menuEntry in visibleHeaderMenus"
                  v-bind:key="menuEntry.menu.name"
                  @click="handleShowSubmenu(menuEntry.index + 1)"
                  @mouseover="
                    (event) => {
                      tabIndex = menuEntry.index + 1;
                      handleShowSubmenu(menuEntry.index + 1);
                      setActiveTab(event);
                      storeTabID(menuEntry.menu.name);
                    }
                  "
                >
                  <a
                    class="nav-link py-4 px-6"
                    @click="
                      (event) => {
                        tabIndex = menuEntry.index + 1;
                        setActiveTab(event);
                        storeTabID(menuEntry.menu.name);
                      }
                    "
                    :data-tab="`${menuEntry.index + 1}`"
                    data-toggle="tab"
                    role="button"
                    aria-selected="true"
                    :id="menuEntry.menu.name"
                    >{{ menuEntry.menu.name }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <KTTopbar></KTTopbar>
        </div>
      </div>
      <div class="header-bottom">
        <div class="container">
          <div
            id="kt_header_navs"
            ref="kt_header_navs"
            class="header-navs header-navs-left nuts-mobile-drawer"
          >
            <div class="nuts-mobile-drawer__heading">
              <span>{{ companyName }}</span>
              <button
                id="kt_header_mobile_close"
                type="button"
                class="nuts-mobile-drawer__close"
                aria-label="Fechar menu"
                @click="closeMobileMenu"
              >
                &times;
              </button>
            </div>
            <nav
              id="kt_header_menu"
              ref="kt_header_menu"
              class="nuts-mobile-drawer__menu"
              aria-label="Menu principal"
            >
              <router-link
                to="/dashboard"
                class="nuts-mobile-drawer__item nuts-mobile-drawer__home"
                :class="{ 'nuts-mobile-drawer__item--active': $route.path === '/dashboard' }"
                @click.native="closeMobileMenu"
              >
                Home
              </router-link>
              <div
                v-for="menuEntry in visibleHeaderMenus"
                :key="menuEntry.index"
                class="nuts-mobile-drawer__group"
              >
                <button
                  type="button"
                  class="nuts-mobile-drawer__item nuts-mobile-drawer__category"
                  :class="{ 'nuts-mobile-drawer__category--active': isMobileGroupActive(menuEntry) }"
                  :aria-expanded="String(isMobileGroupOpen(menuEntry))"
                  @click="toggleMobileGroup(menuEntry)"
                >
                  <span>{{ menuEntry.menu.name }}</span>
                  <span class="nuts-mobile-drawer__chevron" aria-hidden="true">
                    {{ isMobileGroupOpen(menuEntry) ? '⌄' : '›' }}
                  </span>
                </button>
                <div
                  v-if="isMobileGroupOpen(menuEntry)"
                  class="nuts-mobile-drawer__submenus"
                >
                  <template
                    v-for="submenu in visibleSubmenuItems(menuEntry.menu.submenus)"
                  >
                    <router-link
                      v-if="!submenu.disabled"
                      :key="submenu.url"
                      :to="`/${submenu.url}`"
                      class="nuts-mobile-drawer__item nuts-mobile-drawer__submenu"
                      :class="{ 'nuts-mobile-drawer__item--active': isMobileRouteActive(submenu.url) }"
                      @click.native="closeMobileMenu"
                    >
                      {{ submenu.name }}
                    </router-link>
                    <button
                      v-else
                      :key="submenu.url"
                      type="button"
                      class="nuts-mobile-drawer__item nuts-mobile-drawer__submenu nuts-mobile-drawer__item--disabled"
                      @click="handleDisabledMenuClick(submenu)"
                    >
                      {{ submenu.name }}
                    </button>
                  </template>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!-- FOR DESKTOP -->
    <div
      :class="`${
        isMobile || isFullScreen ? 'd-none' : 'header-nuts-desktop'
      } position-relative pl-25`"
    >
      <div
        class="bg-primary position-absolute left-0 d-flex"
        style="
          width: 60px;
          width: 60px;
          width: 60px;
          width: 60px;
          width: 60px;
          height: 60px;
          height: 60px;
          height: 60px;
          height: 60px;
          height: 60px;
          border-bottom-right-radius: 4px;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        "
      >
        <router-link to="/">
          <img
            alt="Logo"
            :src="layoutConfig('self.logo.iconeWhite')"
            class="brand-white-icon mt-1"
          />
        </router-link>
      </div>
      <div class="d-flex justify-content-center align-items-center h-100">
        <div
          class="d-flex cursor-pointer h-100"
          v-for="menuEntry in visibleHeaderMenus"
          v-bind:key="menuEntry.index"
        >
          <div
            :class="`d-flex align-items-center text-dark mr-2 h-100 ${
              isCurrentMenuAcvtive(menuEntry.menu) ? 'menuItemActive' : ''
            }`"
            v-if="menuEntry.menu.checked"
            style="box-sizing: border-box"
          >
            <div
              :id="`popover-${menuEntry.index}`"
              class="d-flex justify-content-center align-items-center w-100 h-100"
            >
              <div
                :class="`d-flex align-items-center text-dark font-weight-bold p-1 h-100`"
                :style="
                  isCurrentMenuAcvtive(menuEntry.menu)
                    ? { marginTop: '2px', transition: 'none' }
                    : { transition: 'none' }
                "
              >
                {{ menuEntry.menu.name }}
              </div>
              <p
                class="text-primary mb-0"
                :style="
                  isCurrentMenuAcvtive(menuEntry.menu)
                    ? { marginTop: '2px', transition: 'none' }
                    : { transition: 'none' }
                "
              >
                <ChevronDown :size="18" />
              </p>
            </div>
          </div>

          <b-popover
            :target="`popover-${menuEntry.index}`"
            triggers="hover"
            placement="bottom"
            class="p-0"
            style="padding: 0 !important"
            boundary-padding="2"
          >
            <div
              style="
                display: flex;
                flex-direction: column;
                margin-right: -15px;
                margin-left: -15px;
              "
            >
              <div
                v-for="subMenuItem in visibleSubmenuItems(
                  submenus[menuEntry.index]
                )"
                :key="subMenuItem.url"
                class="sumenuItem"
                :class="{ disabled: subMenuItem.disabled }"
                v-b-tooltip.hover="
                  subMenuItem.disabled ? subMenuItem.tooltip : null
                "
              >
                <!-- habilitado -->
                <router-link
                  v-if="!subMenuItem.disabled"
                  :to="`/${subMenuItem.url}`"
                  class="menu-link"
                  style="
                    width: 100%;
                    height: 100%;
                    margin-left: -5px;
                    padding: 2px 5px;
                  "
                >
                  <p class="mb-0 text-dark submenuItem">
                    {{ subMenuItem.name }}
                  </p>
                </router-link>

                <!-- desabilitado -->
                <span
                  v-else
                  class="tooltip-wrapper"
                  v-b-tooltip.hover.focus.right="
                    subMenuItem.tooltip ||
                    'Recurso não contratado. Acesse Apps para contratar.'
                  "
                  @click="handleDisabledMenuClick(subMenuItem)"
                  tabindex="0"
                  style="
                    width: 100%;
                    height: 100%;
                    margin-left: -5px;
                    padding: 2px 5px;
                  "
                >
                  <span
                    class="menu-link disabled-link"
                    style="width: 100%; height: 100%"
                  >
                    <p class="mb-0 text-dark submenuItem">
                      {{ subMenuItem.name }}
                    </p>
                  </span>
                </span>
              </div>
            </div>
          </b-popover>
        </div>
      </div>
      <div class="bg-primary pl-3 pr-5 d-flex align-items-center">
        <KTTopbar />
        <p
          class="text-white mb-0 ml-2 cursor-pointer"
          v-b-tooltip="'Sair'"
          @click="handleLogout"
        >
          <Logout :size="20" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import KTLayoutHeaderMenu from "@/assets/js/layout/base/header-menu.js";
import { setUserAccess, userAccessStore } from "../../../userAccessStore.js";
import ChevronDown from "vue-material-design-icons/ChevronDown.vue";
import Logout from "vue-material-design-icons/Logout.vue";
import { LOGOUT } from "@/core/services/store/auth.module";
import swal from "sweetalert";

export default {
  name: "KTHeader",
  data() {
    return {
      tabIndex: 0,
      isFullScreen: false,
      userAccessStore,
      currentTab: -1,
      userAccess: [],
      dropdownActive: false,
      windowWidth: window.innerWidth,
      subMenuShow: false,
      mobileOpenMenu: null,
      icons: [
        [
          "flaticon-business",
          "flaticon-cart",
          "flaticon2-shopping-cart",
          "flaticon2-digital-marketing",
          "flaticon-paper-plane",
        ],
        [
          "flaticon2-percentage",
          "flaticon2-up",
          "flaticon2-down",
          "flaticon-suitcase",
          "flaticon-piggy-bank",
          "flaticon-piggy-bank",
          "flaticon-paper-plane",
        ],
        [
          "flaticon-user-add",
          "flaticon-shopping-basket",
          "flaticon2-list-2",
          "flaticon2-list-2",
          "flaticon2-list-2",
          "flaticon-users",
          "flaticon-users",
          "flaticon-paper-plane",
        ],
        [
          "flaticon2-cup",
          "flaticon-profile",
          "flaticon2-settings",
          "flaticon2-list-2",
          "flaticon2-list-2",
          "flaticon2-settings",
          "flaticon-coins",
          "flaticon2-list",
        ],
      ],
      isAdmin: false,
    };
  },
  components: {
    KTTopbar,
    ChevronDown,
    Logout,
  },
  async mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init(
      this.$refs["kt_header"],
      this.$refs["kt_header_mobile"]
    );
    document.addEventListener(
      "fullscreenchange",
      this.onFullScreenChange,
      false
    );
    document.addEventListener(
      "webkitfullscreenchange",
      this.onFullScreenChange,
      false
    );
    document.addEventListener(
      "mozfullscreenchange",
      this.onFullScreenChange,
      false
    );

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    // Init Header Menu
    KTLayoutHeaderMenu.init(
      this.$refs["kt_header_menu"],
      this.$refs["kt_header_navs"]
    );

    const headerRef = this.$refs["kt_header"];

    headerRef.querySelectorAll("a[class='menu-link']").forEach((item) => {
      item.addEventListener("click", () => {
        KTLayoutHeaderMenu.getOffcanvas().hide();
      });
    });
  },
  computed: {
    ...mapGetters([
      "layoutConfig",
      "getClasses",
      "isNuts",
      "isRevenda",
      "isClienteNutsDireto",
    ]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    companyName() {
      return (
        this.currentUser?.empresa?.nome ||
        this.currentUser?.empresa?.nome_fantasia ||
        this.currentUser?.usuario_empresa?.empresa?.nome ||
        this.currentUser?.usuario_empresa?.empresa?.nome_fantasia ||
        "Nuts"
      );
    },
    headerMenus() {
      return this.userAccess;
    },
    visibleHeaderMenus() {
      return this.headerMenus
        .map((menu, index) => ({ menu, index }))
        .filter(({ menu }) => {
          const submenus = Array.isArray(menu?.submenus) ? menu.submenus : [];
          return menu?.checked && this.visibleSubmenuItems(submenus).length > 0;
        });
    },
    isMobile() {
      return this.windowWidth < 992;
    },
    submenus() {
      if (this.userAccess.length === 0) return [];
      return this.userAccess.map((item) => item.submenus);
    },
    headerMenuEnabled() {
      return !!this.layoutConfig("header.menu.self.display");
    },

    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    headerMenuClasses() {
      const classes = this.getClasses("header_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    widthFluid() {
      return this.layoutConfig("header.self.width") === "fluid";
    },
  },

  watch: {
    currentUser: {
      immediate: true,
      handler(user) {
        this.userAccess = this.normalizeUserAccessResources(user?.recursos);
        this.isAdmin = !!user?.admin;
        setUserAccess(this.userAccess);

        if (this.userAccess.length) {
          this.getCurrentTab();
        }
      },
    },
  },
  methods: {
    isMobileRouteActive(url) {
      const path = `/${url}`;
      return this.$route.path === path || this.$route.path.startsWith(`${path}/`);
    },
    isMobileGroupActive(menuEntry) {
      return this.visibleSubmenuItems(menuEntry.menu.submenus).some((submenu) =>
        this.isMobileRouteActive(submenu.url)
      );
    },
    isMobileGroupOpen(menuEntry) {
      if (this.mobileOpenMenu !== null) {
        return this.mobileOpenMenu === menuEntry.index;
      }
      return this.isMobileGroupActive(menuEntry);
    },
    toggleMobileGroup(menuEntry) {
      this.mobileOpenMenu = this.isMobileGroupOpen(menuEntry)
        ? -1
        : menuEntry.index;
    },
    visibleSubmenuItems(submenus = []) {
      if (!Array.isArray(submenus)) return [];

      return submenus.filter(
        (submenu) =>
          submenu.checked && (!this.isClienteNutsDireto || !submenu.disabled)
      );
    },
    normalizeUserAccessResources(recursos) {
      if (!Array.isArray(recursos)) return [];

      return recursos.map((menu) => {
        const submenus = Array.isArray(menu?.submenus)
          ? menu.submenus.map((submenu) => ({ ...submenu }))
          : [];
        const servicosIndex = submenus.findIndex(
          (submenu) => submenu.url === "servicos"
        );

        if (
          menu?.name === "Serviços" &&
          servicosIndex >= 0 &&
          !submenus.some(
            (submenu) => submenu.url === "lista-precos-servicos"
          )
        ) {
          const servicos = submenus[servicosIndex];
          submenus.splice(servicosIndex + 1, 0, {
            name: "Lista de Preços",
            url: "lista-precos-servicos",
            checked: servicos.checked,
            disabled: servicos.disabled,
            tooltip: servicos.tooltip,
          });
        }

        return { ...menu, submenus };
      });
    },
    handleDisabledMenuClick(item) {
      this.$toast.warning(
        this.isClienteNutsDireto
          ? item?.tooltip ||
              "Este recurso não está contratado. Acesse Apps para contratar."
          : "Esta funcionalidade não está disponível para sua conta."
      );
      this.$router.push({
        name: this.isClienteNutsDireto ? "apps" : "dashboard",
      });
      this.closeMobileMenu();
    },
    handleLogout() {
      swal({
        title: "Deseja realmente fazer o Logoff?",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Sim",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        swal.close();
        swal.stopLoading();
        this.onLogout();
      });
    },
    onFullScreenChange() {
      const fullscreenElement =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement;
      if (fullscreenElement) this.isFullScreen = true;
      else this.isFullScreen = false;
    },
    isCurrentMenuAcvtive(item) {
      const nameOfPath = this.$route.path.replace("/", "");
      const isCurrentActiveItem = item.submenus.find(
        (item) => item.url === nameOfPath
      );
      return !!isCurrentActiveItem;
    },
    handleNavigationClick(url) {
      this.$router.push({ path: `/${url}` });
    },
    handleOpenDropdown(index) {
      this.dropdownActive = true;
      this.$refs[index].visible = true;
    },
    handleCloseDropdown(index) {
      this.$refs[index].visible = false;
      this.dropdownActive = false;
    },
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    handleShowSubmenu(index) {
      if (this.currentTab !== index) {
        this.subMenuShow = true;
        this.currentTab = index;
        return;
      }
      this.subMenuShow = false;
      this.currentTab = -1;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    async getCurrentTab() {
      const selectedTab = JSON.parse(localStorage.getItem("tabSelected"));
      if (!selectedTab?.tabId) return;

      const { tabId, tabIndex } = selectedTab;
      const tabToSelect = document.getElementById(tabId);
      if (!tabToSelect) return;

      const tab = tabToSelect.closest('[role="tablist"]');
      if (!tab) return;

      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }
      tabToSelect.classList.add("active");
      this.tabIndex = tabIndex;
    },
    storeTabID(tabId) {
      localStorage.setItem(
        "tabSelected",
        JSON.stringify({
          tabId,
          tabIndex: this.tabIndex,
        })
      );
    },
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains("nav-link")) {
        target = event.target.closest(".nav-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(target.getAttribute("data-tab"));
      target.classList.add("active");
    },
    closeMobileMenu() {
      const off =
        KTLayoutHeaderMenu.getOffcanvas && KTLayoutHeaderMenu.getOffcanvas();
      if (off && typeof off.hide === "function") off.hide();
      this.subMenuShow = false;
      this.mobileOpenMenu = null;
    },
  },
};
</script>
<style scoped>
.header-nuts-desktop {
  background-color: #fff;
  height: 44.5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.submenuItem:hover {
  color: var(--primary-color);
}

.hover-active .b-dropdown-menu {
  display: block !important;
}

.sumenuItem {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 1rem;
  /* padding: 5px; */
}

.sumenuItem:hover {
  color: var(--primary-color);
  background-color: var(--hover-sub-menu);
  transition: all 0s !important;
}

.sumenuItem:hover::before {
  opacity: 1;
}

.sumenuItem:hover::after {
  opacity: 1;
}

.sumenuItem::before {
  content: "";
  display: inline-block;
  width: 2px;
  height: 25px;
  border-radius: 20%;
  background-color: var(--primary-color);
  /* Cor do círculo */
  margin-right: 5px;
  /* Espaçamento entre o círculo e o texto */
  opacity: 0;
  /* Inicialmente, o círculo é invisível */
  transition: opacity 0.3s;
  /* Adicione uma transição suave */
  /* margin-top: -1px; */
}

.menuItemActive {
  box-sizing: border-box;
  border-bottom: 2px solid var(--primary-color);
  transition: none;
}

.sumenuItem::after {
  content: "";
  display: inline-block;
  width: 2px;
  height: 25px;
  border-radius: 20%;
  background-color: var(--primary-color);
  /* Cor do círculo */
  /* Espaçamento entre o círculo e o texto */
  opacity: 0;
  /* Inicialmente, o círculo é invisível */
  transition: opacity 0.3s;
  /* Adicione uma transição suave */
  /* margin-top: -1px; */
}

@media (max-width: 991.98px) {
  #kt_header_navs.nuts-mobile-drawer {
    width: min(340px, 88vw);
    height: 100vh;
    height: 100dvh;
    max-height: 100dvh;
    left: -100vw;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    box-sizing: border-box;
    background: #fff;
    padding: 0 0 max(16px, env(safe-area-inset-bottom));
  }

  #kt_header_navs.nuts-mobile-drawer.header-navs-on {
    left: 0;
  }

  .nuts-mobile-drawer__heading {
    position: sticky;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 56px;
    padding: 0 16px 0 20px;
    background: #fff;
    border-bottom: 1px solid #edf0f2;
    color: #273339;
    font-size: 18px;
    font-weight: 700;
  }

  .nuts-mobile-drawer__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border: 0;
    background: transparent;
    color: #606a70;
    font-size: 28px;
    line-height: 1;
  }

  .nuts-mobile-drawer__menu {
    padding: 8px 0;
  }

  .nuts-mobile-drawer__item {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 46px;
    padding: 10px 20px;
    border: 0;
    background: transparent;
    color: #354149;
    font-size: 14px;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
  }

  .nuts-mobile-drawer__item:hover,
  .nuts-mobile-drawer__item:focus {
    background: #f6f8fa;
    color: var(--primary-color);
    text-decoration: none;
  }

  .nuts-mobile-drawer__item--active {
    background: #fff1ee;
    color: var(--primary-color);
    font-weight: 600;
  }

  .nuts-mobile-drawer__category {
    justify-content: space-between;
    font-weight: 600;
  }

  .nuts-mobile-drawer__category--active {
    color: var(--primary-color);
  }

  .nuts-mobile-drawer__chevron {
    font-size: 22px;
    line-height: 1;
  }

  .nuts-mobile-drawer__submenus {
    padding: 0 0 4px;
  }

  .nuts-mobile-drawer__submenu {
    padding-left: 36px;
    font-weight: 400;
  }

  .nuts-mobile-drawer__item--disabled {
    color: #9ca4a8;
  }
}
.tooltip-wrapper {
  display: inline-block; /* garante área “clicável/hover” para o tooltip */
}

.disabled-link {
  opacity: 0.5;
  cursor: not-allowed;
}

/* mantém o visual apagado */
.menu-item.disabled .menu-text,
.sumenuItem.disabled .submenuItem {
  color: #999 !important;
}
</style>
